import { apiClient } from '@/shared/api';

export async function emailVerificationApi() {
  try {
    return await apiClient(`email/verification-notification`, {
      method: 'POST',
    });
  } catch (error) {
    console.warn('email verification api error:', error);
    throw error;
  }
}
